/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forestablishedbusinesses2Inputs */

const en_forestablishedbusinesses2 = /** @type {(inputs: Forestablishedbusinesses2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For established businesses`)
};

const de_forestablishedbusinesses2 = /** @type {(inputs: Forestablishedbusinesses2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für etablierte Unternehmen`)
};

/**
* | output |
* | --- |
* | "For established businesses" |
*
* @param {Forestablishedbusinesses2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const forestablishedbusinesses2 = /** @type {((inputs?: Forestablishedbusinesses2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forestablishedbusinesses2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forestablishedbusinesses2(inputs)
	return de_forestablishedbusinesses2(inputs)
});
export { forestablishedbusinesses2 as "forEstablishedBusinesses" }